import React from 'react';
import { Menu } from 'antd';
import { buildMatchPath } from 'react-structure-admin';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import useAuth from 'core/hooks/useAuth';
import { ROLE_ADMIN } from 'constants/types';
import useSubscription from 'core/hooks/useSubscription';

const SettingsMenu = (props) => {
  const { match, routes, collapsed } = props;
  const { features: userFeatures = [], hasRole } = useAuth();
  const history = useHistory();

  const userHasFeature = ({ features = [] }) => {
    return (
      features.length === 0 ||
      features.findIndex((c) => userFeatures.includes(c)) >= 0
    );
  };

  const allowRenderRoute = (route) => {
    if (userHasFeature(route)) {
      return !!route.menu;
    }

    return false;
  };

  const handleGo = (url) => {
    history.push(url);
  };

  const getIcon = (route) => {
    if (!route.menu) {
      return null;
    }

    return <FontAwesomeIcon className="icon" icon={route.menu.icon} />;
  };

  const menu = (route, basePath, sub, index) => {
    if (Array.isArray(route.roles) && !hasRole(...route.roles, ROLE_ADMIN)) {
      return null;
    }

    const url = `${buildMatchPath(match, (basePath || '') + route.path)}`;

    if (route.routes) {
      return (
        <Menu.SubMenu
          key={(basePath || '') + route.path}
          title={
            <div>
              {route?.menu?.icon ? (
                <FontAwesomeIcon className="icon" icon={route.menu.icon} />
              ) : null}
              {collapsed ? null : route.title}
            </div>
          }
        >
          {route.routes
            .filter((c) => !c.hide)
            .map((c) => menu(c, route.path, true, index))}
        </Menu.SubMenu>
      );
    }

    return (
      <Menu.Item
        key={(basePath || '') + route.path}
        onClick={() => handleGo(url)}
        icon={getIcon(route)}
      >
        {route.title}
      </Menu.Item>
    );
  };

  const index = window.location.href.indexOf(match.path);
  const key = window.location.href.substring(
    index + match.path.length,
    window.location.href.length
  );

  const defaultOpenKeys = [];

  // if ((key.match(new RegExp('/', 'g')) || []).length === 2) {
  //   defaultOpenKeys.push(`/${key.split('/').filter((c) => c !== '')[0]}`);
  // }

  return (
    <Menu mode="inline" selectedKeys={[key]} defaultOpenKeys={defaultOpenKeys}>
      {routes &&
        routes
          .filter((c) => !c.hide && allowRenderRoute(c))
          .map((route, index) => menu(route, undefined, false, index))}
    </Menu>
  );
};

export default SettingsMenu;
